interface IHandleChange {
  field: string
  keyValue: string
  onChange: (field: string, keyValue: string) => (value: string | number) => void
}

export const handleNumberColumnChange =
  ({ field, keyValue, onChange }: IHandleChange) =>
  (value: string) => {
    onChange(field, keyValue)(Number(value))
  }
